import { all, takeLatest } from 'redux-saga/effects';
import { fetchPromoStoreTags } from 'store/promoStoreTags/actions';
import fetchPromoStoreTagsWorker from './worker.fetchPromoStoreTags';

function* promoStoreTagsSaga() {
  yield all([takeLatest(fetchPromoStoreTags, fetchPromoStoreTagsWorker)]);
}

export default promoStoreTagsSaga;
